module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-input",
    class: _vm.data.class
  }, [_c('table', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.data.label) + "\n          "), _c('footnotes', {
    attrs: {
      "all-footnotes": _vm.footnotes,
      "local-footnotes": _vm.data.props.footnotes
    }
  })], 1), _vm._v(" "), _c('td', [_c('p', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.data.props.defaultValue))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8f5bdd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/field-types/INPUT.vue
// module id = 705
// module chunks = 0